import { createContext, PropsWithChildren } from 'react';

export const DashboardContext = createContext<any>(null);

export function DashboardContextProvider<TContext>({
  children,
  context,
}: PropsWithChildren<{ context: TContext }>) {
  return <DashboardContext.Provider value={context}>{children}</DashboardContext.Provider>;
}
